webpackJsonp([66],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ErrorPanel',
  props: {
    message: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      default: 'el-icon-warning-outline'
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: false
    },
    backText: {
      type: String,
      default: '返回上一页'
    },
    backIcon: {
      type: String,
      default: 'el-icon-arrow-left'
    }
  },
  methods: {
    handleBack: function handleBack() {
      if (this.$router && this.$router.back) {
        this.$router.back();
      } else if (window && window.history) {
        window.history.back();
      }
    }
  }
});

/***/ }),

/***/ 1413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPanel_vue__ = __webpack_require__(1380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_072bf2be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPanel_vue__ = __webpack_require__(1416);
function injectStyle (ssrContext) {
  __webpack_require__(1414)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-072bf2be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_072bf2be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1414:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1415);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("62566b31", content, true, {});

/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".error-panel[data-v-072bf2be]{padding:40px 20px;min-height:260px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;background:#fff;border-radius:4px;-webkit-box-shadow:0 2px 12px rgba(0,0,0,.1);box-shadow:0 2px 12px rgba(0,0,0,.1);-webkit-box-sizing:border-box;box-sizing:border-box}.error-panel__icon-wrap[data-v-072bf2be]{margin-bottom:20px}.error-panel__icon[data-v-072bf2be]{font-size:64px;color:#f56c6c}.error-panel__text[data-v-072bf2be]{font-size:20px;font-weight:500;color:#303133;margin:0 0 20px;max-width:520px;line-height:1.6;word-break:break-all}.error-panel__actions[data-v-072bf2be]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/workspace/src/components/ErrorPanel.vue"],"names":[],"mappings":"AACA,8BAA8B,kBAAkB,iBAAiB,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,kBAAkB,gBAAgB,kBAAkB,6CAA8C,qCAAsC,8BAA8B,qBAAqB,CAC/hB,AACD,yCAAyC,kBAAkB,CAC1D,AACD,oCAAoC,eAAe,aAAa,CAC/D,AACD,oCAAoC,eAAe,gBAAgB,cAAc,gBAAkB,gBAAgB,gBAAgB,oBAAoB,CACtJ,AACD,uCAAuC,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,sBAAsB,CAC9J","file":"ErrorPanel.vue","sourcesContent":["\n.error-panel[data-v-072bf2be]{padding:40px 20px;min-height:260px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;background:#fff;border-radius:4px;-webkit-box-shadow:0 2px 12px rgba(0,0,0,0.1);box-shadow:0 2px 12px rgba(0,0,0,0.1);-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.error-panel__icon-wrap[data-v-072bf2be]{margin-bottom:20px\n}\n.error-panel__icon[data-v-072bf2be]{font-size:64px;color:#F56C6C\n}\n.error-panel__text[data-v-072bf2be]{font-size:20px;font-weight:500;color:#303133;margin:0 0 20px 0;max-width:520px;line-height:1.6;word-break:break-all\n}\n.error-panel__actions[data-v-072bf2be]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-panel"},[(_vm.showIcon)?_c('div',{staticClass:"error-panel__icon-wrap"},[_c('i',{class:[_vm.iconClass, 'error-panel__icon']})]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"error-panel__text"},[_vm._t("default",[_vm._v(_vm._s(_vm.message))])],2),_vm._v(" "),(_vm.showBack || _vm.$slots.actions)?_c('div',{staticClass:"error-panel__actions"},[_vm._t("actions",[(_vm.showBack)?_c('el-button',{attrs:{"type":"primary","icon":_vm.backIcon},on:{"click":_vm.handleBack}},[_vm._v("\n        "+_vm._s(_vm.backText)+"\n      ")]):_vm._e()])],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return forceFinishRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {};

var formRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入回款名称', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入至少2个字符', 'string'), { min: 2 })],
  customerid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择客户名称', 'integer'))],
  type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择回款类型', 'integer'))],
  receipt_info_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择客户名称', 'integer'))],
  desc: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入回款描述', 'string'))],
  our_company_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择收款公司', 'integer'))],
  our_company_account_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择收款账户', 'integer'))],
  collection_amount: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入回款金额', 'string'))],
  received_date: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择回款日期', 'string'))],
  // mail_to: [
  //   {...makeRule('请选择收件人', 'array')},
  // ],
  // memo: [
  //   {...makeRule('请输入回款备注', 'string')},
  // ],
  attached_file: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请上传附件', 'array'))]
};

var forceFinishRules = {
  reason: [{ required: true, message: '核销说明不能为空', trigger: 'blur' }]
};

/***/ }),

/***/ 2958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__received_payment_rules_js__ = __webpack_require__(2118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ErrorPanel_vue__ = __webpack_require__(1413);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ErrorPanel: __WEBPACK_IMPORTED_MODULE_5__components_ErrorPanel_vue__["a" /* default */]
  },
  data: function data() {
    return {
      id: 0,
      formRules: __WEBPACK_IMPORTED_MODULE_4__received_payment_rules_js__["b" /* formRules */],
      showErrorMsg: false,
      detailErrorMsg: '',
      receiptOptions: [],
      form: {
        customerid: '',
        receipt_info_id: null,
        desc: '',
        type: '',
        our_company_id: '',
        our_company_account_id: null,
        collection_amount: '',
        received_date: '',
        mail_to: [],
        memo: '',
        attached_file: []
      },
      receiptInfo: {},
      allMineManagedCompanies: [],
      activeMineManagedCompanies: [],
      showReceiptErr: false,
      companyErrorMessage: '',
      fileList: [],
      loadingFileUpload: false,
      dateTimePickerRangeOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    collectionTypeText: function collectionTypeText(state) {
      return state.receivedPayment.collectionTypeText;
    },
    user: function user(state) {
      return state.login.user;
    }
  }), {
    routerPath: function routerPath() {
      return 'received-' + this.$route.meta.type;
    }
  }),
  watch: {
    'form.receipt_info_id': function formReceipt_info_id(newValue, oldValue) {
      // 判断 receipt_info_id 是否发生了变化，减少对接口无意义的调用
      if (this.form.receipt_info_id > 0 && newValue * 1 !== oldValue * 1) {
        this.setCurrentReceiptInfo();
      }
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setMineCompanies();

            case 2:
              if (!_this.showErrorMsg) {
                _context.next = 4;
                break;
              }

              return _context.abrupt('return');

            case 4:

              _this.id = _this.$route.params.id || 0;
              _this.id > 0 && _this.setDetailData(_this.id);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerReceiptDetail', 'getCompanyAccountManagementTable', 'getCompanyAccountManagementDetail']), Vuex.mapActions(['getCustomerTable', 'getCustomerDetail', 'getPlatformUsersIndex', 'getPlatformUsersDetail']), {
    getForm: function getForm() {
      return filter.copyJson(this.form);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.id ? _this2.update(_this2.id) : _this2.create();
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create() {
      var _this3 = this;

      request.common('createReceivedPaymentData', this.getForm()).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this3.$data.form, _this3.$options.data.call(_this3).form);
          _this3.$refs.form.resetFields();
          _this3.$refs.upload.clearFiles();
        }, function () {
          _this3.goApproveTable();
        });
      });
    },
    update: function update(id) {
      var _this4 = this;

      request.common('updateReceivedPaymentData', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
        _this4.$confirm('数据修改成功，请同步更新金蝶中的收款单数据', '提示', { type: 'success' }).then(function () {
          _this4.goApproveTable();
        });
      });
    },
    goApproveTable: function goApproveTable() {
      this.$router.push({ path: '/received-approval/table/' });
    },
    onChangeCustomerId: function onChangeCustomerId() {
      var _this5 = this;

      this.receiptOptions = [];
      if (this.form.customerid > 0) {
        var id = this.form.customerid;
        request.page('getCustomerReceiptOptions', { customerid: id }).then(function (_ref) {
          var data = _ref.data;

          _this5.receiptOptions = data;
          _this5.resetReceiptInfo();
        });
      } else {
        this.resetReceiptInfo();
      }
    },
    setMineCompanies: function setMineCompanies() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this6.user.usertype * 1 === 1)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return request('getFinCenterConfigs').then(function (_ref2) {
                  var data = _ref2.data;

                  _this6.setupMineCompanyList(data.payment_apply_our_company_source);
                }).catch(function (e) {
                  _this6.detailErrorMsg = String(e).replace(/^Error:\s*/i, '');
                  _this6.showErrorMsg = true;
                });

              case 3:
                _context2.next = 7;
                break;

              case 5:
                _context2.next = 7;
                return request('getMineManagedCompaniesApi').then(function (_ref3) {
                  var data = _ref3.data;

                  _this6.setupMineCompanyList(data);
                }).catch(function (e) {
                  _this6.detailErrorMsg = String(e).replace(/^Error:\s*/i, '');
                  _this6.showErrorMsg = true;
                });

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    setupMineCompanyList: function setupMineCompanyList(data) {
      this.allMineManagedCompanies = data.map(function (item) {
        item.id = item.id * 1;
        return item;
      });
      this.activeMineManagedCompanies = this.allMineManagedCompanies.filter(function (company) {
        return company.is_disabled === 0;
      });
      if (this.activeMineManagedCompanies.length > 0) {
        this.showErrorMsg = false;
      } else {
        this.detailErrorMsg = '您所负责的公司列表为空,或已负责的公司均被禁用,请联系超管分配可用的负责公司';
        this.showErrorMsg = true;
      }
    },
    resetReceiptInfo: function resetReceiptInfo() {
      this.form.receipt_info_id = null;
      this.receiptInfo = {
        customerid: null,
        company_name: null,
        tax_number: null,
        bank_info: null,
        address_phone: null
      };
    },
    setCurrentReceiptInfo: function setCurrentReceiptInfo() {
      var _this7 = this;

      if (this.form.customerid > 0) {
        var id = this.form.customerid;
        this.showReceiptErr = false;
        request.page('getCustomerReceiptOptions', { customerid: id }).then(function (_ref4) {
          var data = _ref4.data;

          _this7.receiptOptions = data;

          var findSuccess = false;
          for (var dataKey in data) {
            if (data[dataKey].id === _this7.form.receipt_info_id) {
              _this7.receiptInfo = _.cloneDeep(data[dataKey]);
              findSuccess = true;
            }
          }
          if (!findSuccess && _this7.form.receipt_info_id > 0) {
            _this7.resetReceiptInfo();
            _this7.showReceiptErr = true;
          }
        });
      } else {
        this.resetReceiptInfo();
      }
    },
    handleExceed: function handleExceed(files, fileList, max) {
      this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 ' + max + ' \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ' + files.length + ' \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ' + (files.length + fileList.length) + ' \u4E2A\u6587\u4EF6');
    },
    beforeRemove: function beforeRemove(file, fileList, formField) {
      var fileTemp = void 0;
      if (file.raw) {
        fileTemp = file.raw;
      } else {
        fileTemp = file;
      }
      var index = this.getFileListIndex(fileTemp, fileList);
      if (index > -1) {
        formField.splice(index, 1);
      }
    },
    getFileListIndex: function getFileListIndex(file, fileList) {
      for (var i = 0; i < fileList.length; i++) {
        var fileTemp = void 0;
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw;
        } else {
          fileTemp = fileList[i];
        }
        if (file === fileTemp) {
          return i;
        }
      }
      return -1;
    },
    onChangeFile: function onChangeFile(file, fileList, formField) {
      var isLt5M = file.raw.size / 1024 / 1024 < 50;
      if (!isLt5M) {
        this.$message.error('文件内容必须小于50MB!');
        this.$refs.upload.uploadFiles.pop();
        return false;
      }
      this.onUploadFile(file.raw, fileList, formField);
    },
    onUploadFile: function onUploadFile(file, fileList, formField) {
      var _this8 = this;

      this.loadingFileUpload = true;

      var formData = new FormData();
      formData.append('file', file);
      this.id && formData.append('apply_id', this.id);
      return request.alert('finCenterUploadPaymentApplyFile', formData).then(function (_ref5) {
        var data = _ref5.data;

        _this8.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        var index = _this8.getFileListIndex(file, fileList);

        var type = file.name.split('.').pop().toLowerCase();
        if (['jpeg', 'jpg', 'png'].includes(type)) {
          type = 'pic';
        } else if (['pdf'].includes(type)) {
          type = 'pdf';
        } else if (['eml', 'html', 'htm'].includes(type)) {
          type = 'eml';
        } else if (['xlsx', 'doc', 'docx'].includes(type)) {
          type = 'office';
        } else if (['zip'].includes(type)) {
          type = 'zip';
        }
        if (index > -1) {
          formField[index] = { name: file.name, url: data, type: type };
        }
        _this8.loadingFileUpload = false;
      }).catch(function (_) {
        _this8.$refs.upload.uploadFiles.pop();
        _this8.loadingFileUpload = false;
      });
    },
    changeOurComId: function changeOurComId() {
      this.form.our_company_account_id = null;
      this.companyErrorMessage = '';
    },
    isFinancePage: function isFinancePage() {
      return this.$route.meta.type === 'approval';
    },
    setDetailData: function setDetailData(id) {
      var _this9 = this;

      var params = {
        id: id,
        forFinance: this.isFinancePage() ? 1 : 0
      };
      request('getNewReceivedPaymentDetail', params).then(function (_ref6) {
        var data = _ref6.data;

        _this9.form = _.cloneDeep(data);
        var usedComName = _.get(_this9.form, 'our_company.name', '');
        var isValidCompany = _this9.allMineManagedCompanies.find(function (company) {
          return company.id === _this9.form.our_company_id;
        });
        if (!isValidCompany) {
          _this9.form.our_company_id = null;
          _this9.companyErrorMessage = '\u6240\u9009\u6536\u6B3E\u516C\u53F8\u3010' + usedComName + '\u3011\u4E0D\u5728\u60A8\u7684\u8D1F\u8D23\u8303\u56F4\u5185\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9';
        } else {
          if (isValidCompany.is_disabled) {
            _this9.form.our_company_id = null;
            _this9.companyErrorMessage = '\u6240\u9009\u6536\u6B3E\u516C\u53F8\u3010' + usedComName + '\u3011\u5DF2\u88AB\u7981\u7528\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9';
          } else {
            _this9.companyErrorMessage = '';
          }
        }
        _this9.form.customerid = data.customerid > 0 ? data.customerid + '' : null;
        _this9.form.type = _this9.form.type + '';
        _this9.fileList = data.attached_file;
        _this9.setCurrentReceiptInfo();
        _this9.showErrorMsg = false;
      }).catch(function (e) {
        _this9.detailErrorMsg = String(e).replace(/^Error:\s*/i, '');
        _this9.showErrorMsg = true;
      });
    }
  })
});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceivedPaymentForm_vue__ = __webpack_require__(2958);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f21894_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceivedPaymentForm_vue__ = __webpack_require__(5359);
function injectStyle (ssrContext) {
  __webpack_require__(5353)
  __webpack_require__(5355)
  this["$style"] = __webpack_require__(5357)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43f21894"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceivedPaymentForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f21894_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceivedPaymentForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5353:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5354);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("694bf497", content, true, {});

/***/ }),

/***/ 5354:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ReceivedPaymentForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5355:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5356);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("48542071", content, true, {});

/***/ }),

/***/ 5356:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".receipt-info[data-v-43f21894]{display:block;margin-bottom:5px}.receipt-info-text[data-v-43f21894]{font-weight:700}.receipt-info-block[data-v-43f21894]{width:470px;border-radius:5px;border:2px solid transparent;background-clip:padding-box;background-color:hsla(0,0%,50%,.1);padding:5px 10px}", "", {"version":3,"sources":["/workspace/src/views/received-payment/pages/ReceivedPaymentForm.vue"],"names":[],"mappings":"AACA,+BAA+B,cAAc,iBAAiB,CAC7D,AACD,oCAAoC,eAAgB,CACnD,AACD,qCAAqC,YAAY,kBAAkB,6BAA6B,4BAA4B,mCAAuC,gBAAgB,CAClL","file":"ReceivedPaymentForm.vue","sourcesContent":["\n.receipt-info[data-v-43f21894]{display:block;margin-bottom:5px\n}\n.receipt-info-text[data-v-43f21894]{font-weight:bold\n}\n.receipt-info-block[data-v-43f21894]{width:470px;border-radius:5px;border:2px solid transparent;background-clip:padding-box;background-color:rgba(128,128,128,0.1);padding:5px 10px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5357:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5358);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("cae5043e", content, true, {});

/***/ }),

/***/ 5358:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ReceivedPaymentForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":("/" + _vm.routerPath + "/table")}},[_vm._v("回款列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),(_vm.showErrorMsg)?[(_vm.detailErrorMsg)?_c('error-panel',{attrs:{"message":_vm.detailErrorMsg,"show-back":""}}):_vm._e()]:[_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("新增回款")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"large"},[_c('el-form-item',{attrs:{"label":"客户名称","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入客户名称/编号搜索","query-request":function (_){ return _vm.getCustomerTable(Object.assign(_, {type: 'all'})); },"find-request":_vm.getCustomerDetail},on:{"change":_vm.onChangeCustomerId},model:{value:(_vm.form.customerid),callback:function ($$v) {_vm.$set(_vm.form, "customerid", $$v)},expression:"form.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"抬头","prop":"receipt_info_id"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.form.receipt_info_id),callback:function ($$v) {_vm.$set(_vm.form, "receipt_info_id", $$v)},expression:"form.receipt_info_id"}},_vm._l((_vm.receiptOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),(_vm.showReceiptErr)?_c('el-form-item',{attrs:{"label":"","prop":"null"}},[_c('span',{staticStyle:{"color":"red"}},[_vm._v("当前客户下未找到此 id 对应的客户开票抬头信息，抬头数据已重置")])]):_vm._e(),_vm._v(" "),_c('el-form-item',[_c('div',{staticClass:"receipt-info-block"},[_c('h3',[_vm._v("客户开票信息")]),_vm._v(" "),_c('span',{staticClass:"receipt-info"},[_c('span',{staticClass:"receipt-info-text"},[_vm._v("公司名称: ")]),_vm._v(_vm._s(_vm.receiptInfo.company_name)+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"receipt-info"},[_c('span',{staticClass:"receipt-info-text"},[_vm._v("开户行及账号: ")]),_vm._v(_vm._s(_vm.receiptInfo.bank_info)+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"receipt-info"},[_c('span',{staticClass:"receipt-info-text"},[_vm._v("地址及电话: ")]),_vm._v(_vm._s(_vm.receiptInfo.address_phone)+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"receipt-info"},[_c('span',{staticClass:"receipt-info-text"},[_vm._v("税号: ")]),_vm._v(_vm._s(_vm.receiptInfo.tax_number)+"\n              ")])])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款描述","prop":"desc"}},[_c('el-input',{attrs:{"placeholder":"请输入回款描述"},model:{value:(_vm.form.desc),callback:function ($$v) {_vm.$set(_vm.form, "desc", $$v)},expression:"form.desc"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款类型","prop":"type"}},[_c('el-select',{staticClass:"width-max",model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}},_vm._l((_vm.collectionTypeText),function(label,value){return _c('el-option',{key:value,attrs:{"label":label,"value":value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"收款公司","prop":"our_company_id"}},[_c('el-select',{staticClass:"width-max",on:{"change":_vm.changeOurComId},model:{value:(_vm.form.our_company_id),callback:function ($$v) {_vm.$set(_vm.form, "our_company_id", $$v)},expression:"form.our_company_id"}},_vm._l((_vm.activeMineManagedCompanies),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1),_vm._v(" "),(_vm.companyErrorMessage)?_c('div',{staticStyle:{"color":"#f56c6c","font-size":"12px","line-height":"1","padding-top":"4px"}},[_vm._v("\n              "+_vm._s(_vm.companyErrorMessage)+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"收款账户","prop":"our_company_account_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","disabled":!_vm.form.our_company_id,"placeholder":"请选择收款账户","query-params":{ our_company_id: _vm.form.our_company_id, is_disabled: 0 },"query-request":_vm.getCompanyAccountManagementTable,"find-request":_vm.getCompanyAccountManagementDetail},model:{value:(_vm.form.our_company_account_id),callback:function ($$v) {_vm.$set(_vm.form, "our_company_account_id", $$v)},expression:"form.our_company_account_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款金额","prop":"collection_amount"}},[_c('el-input',{attrs:{"placeholder":"请输入回款金额"},model:{value:(_vm.form.collection_amount),callback:function ($$v) {_vm.$set(_vm.form, "collection_amount", $$v)},expression:"form.collection_amount"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款日期","prop":"received_date"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd","picker-options":_vm.dateTimePickerRangeOptions,"type":"date","placeholder":"选择日期"},model:{value:(_vm.form.received_date),callback:function ($$v) {_vm.$set(_vm.form, "received_date", $$v)},expression:"form.received_date"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"收件人","prop":"mail_to"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入管理员名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.form.mail_to),callback:function ($$v) {_vm.$set(_vm.form, "mail_to", $$v)},expression:"form.mail_to"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款备注","prop":"memo"}},[_c('el-input',{attrs:{"placeholder":"请输入回款备注"},model:{value:(_vm.form.memo),callback:function ($$v) {_vm.$set(_vm.form, "memo", $$v)},expression:"form.memo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"附件","prop":"attached_file"}},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"","auto-upload":false,"on-change":function (file, fileList) {_vm.onChangeFile(file, fileList, this$1.form.attached_file)},"before-remove":function (file, fileList) {_vm.beforeRemove(file, fileList, this$1.form.attached_file)},"multiple":"","limit":20,"on-exceed":function (file, fileList) {_vm.handleExceed(file, fileList, 20)},"file-list":_vm.fileList,"accept":".jpg, .jpeg, .png, .pdf, .eml, .html, .htm, .xls, .xlsx, .doc, .docx, .zip"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"点击上传附件","placement":"right"}},[_c('el-button',{attrs:{"size":"small","loading":_vm.loadingFileUpload,"type":"primary"}},[_vm._v("点击上传\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("请上传PNG/JPG/PDF/EML/HTML/WORD/EXCEL/ZIP文件，仅支持上传20个文件，20以上建议上传zip格式\n              ")])],1)],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.loadingFileUpload,"native-type":"submit"}},[_vm._v("保存\n        ")])],1)],1)],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/received-payment-form.f33085c0b1f3c19ad899.js